import React, { useEffect, useState } from 'react';
import { api, clearSession, replaceToken } from '../lib/api';

/* Set or change your password. Someone who has only used Google can set a
   first one without an old one; after that, changing it needs the current one —
   which is also how a member replaces a temporary password an admin gave them. */

export default function PasswordSettings({ notify }) {
  const [hasPassword, setHasPassword] = useState(null);
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    api.me().then((me) => setHasPassword(Boolean(me.has_password))).catch(() => {});
  }, []);

  if (hasPassword === null) return null;

  const mismatch = confirm && next !== confirm;
  const ready = next.length >= 10 && next === confirm && (!hasPassword || current);

  async function save(e) {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      const r = await api.changePassword(current, next);
      // Other devices are signed out by the change; this one keeps going.
      replaceToken(r?.access_token);
      setCurrent(''); setNext(''); setConfirm('');
      setHasPassword(true);
      notify?.(hasPassword ? 'Password changed' : 'Password set — you can now sign in with your email');
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  async function signOutEverywhere() {
    if (!window.confirm('Sign out of B/N on every device, including this one?')) return;
    try {
      await api.signOutEverywhere();
    } catch { /* signing out locally anyway */ }
    clearSession();
    window.location.reload();
  }

  return (
    <form className="pw-form" onSubmit={save}>
      {hasPassword && (
        <>
          <label className="flabel" htmlFor="pw-current">Current password</label>
          <input id="pw-current" className="in" type="password" autoComplete="current-password"
            value={current} onChange={(e) => setCurrent(e.target.value)} />
        </>
      )}
      <label className="flabel" htmlFor="pw-new">New password</label>
      <input id="pw-new" className="in" type="password" autoComplete="new-password"
        value={next} onChange={(e) => setNext(e.target.value)} />
      <label className="flabel" htmlFor="pw-confirm">Type it again</label>
      <input id="pw-confirm" className="in" type="password" autoComplete="new-password"
        value={confirm} onChange={(e) => setConfirm(e.target.value)} />
      <p className="muted-sm">{mismatch ? "Those don't match." : 'At least 10 characters.'}</p>
      {error && <p className="pe-field-error" role="alert">{error}</p>}
      <div>
        <button className="btn primary" type="submit" disabled={busy || !ready}>
          {busy ? 'Saving…' : hasPassword ? 'Change password' : 'Set password'}
        </button>
      </div>
      <p className="muted-sm">
        Changing your password signs you out everywhere else.{' '}
        <button type="button" className="linklike" onClick={signOutEverywhere}>Sign out of all devices</button>
      </p>
    </form>
  );
}
